import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppSettings } from '../config/app-settings.js';
import relatoriosRTF from '../pages/carvao/relatorios-rtf-carvao.js';

const MAX_QNTD_CARVAO_REALTORIO = 201;

/**
* Gera o relatório em massa (PDF/RTF) dos resultados de uma busca.
*
* @param {Array|false} selectedCoalList  Lista de registros da busca já com `espec` calculado, ou `false` quando o total ultrapassa MAX_QNTD_CARVAO_REALTORIO.
* @param {Array|null} fieldList          Estrutura de campos usada na geração do relatório RTF.
*/

export default function useSearchReport(selectedCoalList, fieldList) {
    const { t, i18n } = useTranslation();
    const { ...settings } = useContext(AppSettings);

    const [ searchReportModal, setSearchReportModal ] = useState(false);
    const [ printCoalList, setPrintCoalList ] = useState([]);

    const toggleSearchReportModal = () => setSearchReportModal(!searchReportModal);

    const openSearchReportModal = () => setSearchReportModal(true);

    const handleReportType = (type) => {
        if(selectedCoalList == false){
            toggleSearchReportModal();
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('relatório.alerta.limiteDeTamanho', {size: MAX_QNTD_CARVAO_REALTORIO-1}));
            return;
        }

        if(type === 'search-pdf'){
            setPrintCoalList(selectedCoalList);
            toggleSearchReportModal();
            setTimeout(function(){
                window.print();
                settings.handleSetAlert('success', t('alerta.titulo.sucesso'), t('relatório.alerta.relatórioFeito'));
            }, 200);
        }
        else if(type === 'search-rtf'){
            toggleSearchReportModal();
            relatoriosRTF.getCoalReport(selectedCoalList, fieldList, t, i18n);
            settings.handleSetAlert('success', t('alerta.titulo.sucesso'), t('relatório.alerta.relatórioFeito'));
        }
    }

    return { MAX_QNTD_CARVAO_REALTORIO, printCoalList, searchReportModal,
        toggleSearchReportModal, openSearchReportModal, handleReportType
    };
}